import axios from 'axios'
import {IWorkflowFormInputs} from '../../types/types'
import {Dispatch, SetStateAction} from 'react'
import {getAuth, setAuth} from '../../app/modules/auth/core/AuthHelpers'
import {refresh} from '../../app/modules/auth/core/_requests'
import {findWorkflowByBackendUrl} from '../data/global/workflow'
import {isRunningOnKlevereDomain, isRunningOnProductionDomain} from '../../white-label/permission'
interface IUseChatGPTRequestProps {
  axiosURL: string
  requiredQuestions: [] | any
  additionalQuestions: [] | any
  optionalSelect: [] | any
  inputs: IWorkflowFormInputs
  axiosHeader: string
  setCurrentAnswer: Function
  myRef: React.RefObject<HTMLFormElement>
  setIsLoading?: Function
  setError: Function
  activeIndex?: number | null
  setActiveIndex?: Dispatch<SetStateAction<number | null>>
  handleSaveActivity?: Function
  setExtraData?: Function
  setIsStreaming?: Function
}

interface IUseChatGPTRequestResult {
  handleForm: (e: React.FormEvent | any) => void
}

const useChatGPTRequest = ({
  myRef,
  axiosURL,
  axiosHeader,
  requiredQuestions,
  additionalQuestions,
  optionalSelect,
  inputs,
  setCurrentAnswer,
  setIsLoading = () => {},
  setError,
  activeIndex,
  setActiveIndex,
  handleSaveActivity = () => {},
  setExtraData,
  setIsStreaming,
}: IUseChatGPTRequestProps): IUseChatGPTRequestResult => {
  const API_URL = process.env.REACT_APP_GPT_API_URL

  const handleForm = (e: React.FormEvent | any) => {
    e?.type === 'submit' && e.preventDefault()
    const form = myRef.current

    setCurrentAnswer('')

    if (form && form.checkValidity()) {
      setIsLoading(true)

      // if (
      //   [
      //     'generateBlogArticle',
      //     'generateNewsletterPost',
      //     'generatePressRelease',
      //     'generateJobDescription',
      //     'generateRecruitmentStrategy',
      //     'generatePerformanceEvaluation',
      //     'generateDigitalAd',
      //   ].includes(axiosURL)
      // ) {
      //   // Handle Stream Response from GPT
      //   ;(async () => {
      //     await handleStreamResponse()
      //   })()
      // } else {
      setCurrentAnswer('AI is working on your output...')

      axios
        .post(`${API_URL}/${axiosURL}`, {
          [requiredQuestions[0].axiosParamName]: inputs.requiredQuestion1,
          [requiredQuestions[1]?.axiosParamName]: inputs.requiredQuestion2,
          [requiredQuestions[2]?.axiosParamName]: inputs.requiredQuestion3,
          [requiredQuestions[3]?.axiosParamName]: inputs.requiredQuestion4,
          [requiredQuestions[4]?.axiosParamName]: inputs.requiredQuestion5,
          [requiredQuestions[5]?.axiosParamName]: inputs.requiredQuestion6,
          [additionalQuestions[0]?.axiosParamName]: inputs.additionalQuestion1,
          [additionalQuestions[1]?.axiosParamName]: inputs.additionalQuestion2,
          [additionalQuestions[2]?.axiosParamName]: inputs.additionalQuestion3,
          [optionalSelect[0]?.axiosParamName]: inputs.optionalSelect1,
          [optionalSelect[1]?.axiosParamName]: inputs.optionalSelect2,
          [optionalSelect[2]?.axiosParamName]: inputs.optionalSelect3,
          [optionalSelect[3]?.axiosParamName]: inputs.optionalSelect4,
          [optionalSelect[4]?.axiosParamName]: inputs.optionalSelect5,
          [optionalSelect[5]?.axiosParamName]: inputs.optionalSelect6,

          social_media: inputs.media,
          amountValue: inputs.variations,
          outputLanguage: inputs.language,
          workflow_uuid: findWorkflowByBackendUrl(axiosURL)?.uuid,
          white_label_uuid: !isRunningOnKlevereDomain()
            ? '550e8400-e29b-41d4-a716-446655440001'
            : null,
          // linkedin_url: inputs.linkedin_url,
        })
        .then((res) => {
          setCurrentAnswer(res.data[axiosHeader].message)

          if (setExtraData) {
            setExtraData(res.data[axiosHeader]?.extraData)
          }

          handleSaveActivity(res.data[axiosHeader].message, res.data[axiosHeader]?.extraData)
        })
        .then(() => {
          if (setActiveIndex && (activeIndex || activeIndex === 0)) {
            setTimeout(() => {
              setActiveIndex(activeIndex + 1)
            }, 3000)
          }
        })
        .catch((err) => {
          setCurrentAnswer(
            `${
              err?.response?.data?.message
                ? err.response.data.message
                : 'An error occurred. Please contact customer support!'
            }`
          )

          if (setActiveIndex && (activeIndex || activeIndex === 0)) {
            setTimeout(() => {
              setActiveIndex(activeIndex + 1)
            }, 3000)
          }

          setError(err?.response?.data?.message ?? 'An error occurred')
          handleSaveActivity(err?.response?.data?.message ?? '')
        })
        .finally(() => {
          setIsLoading(false)
        })
      // }
    }
  }

  // Why we are using fetch instead of axios? (https://github.com/axios/axios/issues/1219)
  // As we use refresh strategies to get new tokens in Axios global configurations, for Fetch, we need to obtain new tokens with each request.
  const handleStreamResponse = async () => {
    const auth = await getAuth()

    console.log('Saita inputs', inputs)

    const makeRequest = async (accessToken: string) => {
      const response = await fetch(`${API_URL}/${axiosURL}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          [requiredQuestions[0].axiosParamName]: inputs.requiredQuestion1,
          [requiredQuestions[1]?.axiosParamName]: inputs.requiredQuestion2,
          [requiredQuestions[2]?.axiosParamName]: inputs.requiredQuestion3,
          [requiredQuestions[3]?.axiosParamName]: inputs.requiredQuestion4,
          [requiredQuestions[4]?.axiosParamName]: inputs.requiredQuestion5,
          [requiredQuestions[5]?.axiosParamName]: inputs.requiredQuestion6,
          [additionalQuestions[0]?.axiosParamName]: inputs.additionalQuestion1,
          [additionalQuestions[1]?.axiosParamName]: inputs.additionalQuestion2,
          [additionalQuestions[2]?.axiosParamName]: inputs.additionalQuestion3,
          [optionalSelect[0]?.axiosParamName]: inputs.optionalSelect1,
          [optionalSelect[1]?.axiosParamName]: inputs.optionalSelect2,
          [optionalSelect[2]?.axiosParamName]: inputs.optionalSelect3,
          [optionalSelect[3]?.axiosParamName]: inputs.optionalSelect4,
          [optionalSelect[4]?.axiosParamName]: inputs.optionalSelect5,
          [optionalSelect[5]?.axiosParamName]: inputs.optionalSelect6,
          social_media: inputs.media,
          amountValue: inputs.variations,
          outputLanguage: inputs.language,
          workflow_uuid: findWorkflowByBackendUrl(axiosURL)?.uuid,
          white_label_uuid: !isRunningOnKlevereDomain()
            ? '550e8400-e29b-41d4-a716-446655440001'
            : null,
        }),
      })
      return response
    }

    try {
      let response = await makeRequest(auth?.access_token ?? '')

      if (response.status === 401) {
        // Refresh token and retry
        const newAuth = await refresh(auth?.refresh_token)
        await setAuth(newAuth.data)
        response = await makeRequest(newAuth.data.access_token)
      }

      if (!response.body) throw new Error('No response body')

      setIsLoading(false)
      if (setIsStreaming) setIsStreaming(true)

      const reader = response.body.getReader()
      const decoder = new TextDecoder('utf-8')
      let fullResponseText = ''

      while (true) {
        const {done, value} = await reader.read()
        if (done) break
        const chunk = decoder.decode(value, {stream: true})
        fullResponseText += chunk
        setCurrentAnswer((prev: any) => prev + chunk)
      }

      handleSaveActivity(fullResponseText)
    } catch (err) {
      setCurrentAnswer('An error occurred. Please contact customer support!')
      setError('An error occurred.')
      handleSaveActivity('')
    } finally {
      setIsLoading(false)
      if (setIsStreaming) setIsStreaming(false)
      if (setActiveIndex && (activeIndex || activeIndex === 0)) {
        setTimeout(() => setActiveIndex(activeIndex + 1), 3000)
      }
    }
  }

  return {handleForm}
}

export default useChatGPTRequest
